import React from "react";
import { useTranslation } from "react-i18next";
import InternalLink from "../../components/InternalLink";

function DocsIntro() {
    const { t } = useTranslation();

    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <div className="mb-8">
                <h1 className="text-3xl font-semibold mb-2">
                    {t("intro.title")}
                </h1>
                <p className="text-gray-600 ">
                    {t("intro.welcome")}
                </p>

                <div className="mt-6">
                    <p className="text-gray-600 ">
                        {t("intro.description")}
                    </p>
                </div>
            </div>

            <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                    {t("principles.title")}
                </h2>

                <div className="bg-gray-50  p-4 rounded-lg mb-10 border-l-4 border-purple-600 rounded-none">
                    <h3 className="text-xl font-medium mb-2">
                        {t("principles.principle1.title")}
                    </h3>
                    <p className="text-gray-600  mb-3">
                        {t("principles.principle1.description")}
                    </p>
                </div>

                <div className="bg-gray-50  p-4 rounded-lg mb-10 border-l-4 border-blue-600 rounded-none">
                    <h3 className="text-xl font-medium mb-2">
                        {t("principles.principle2.title")}
                    </h3>
                    <p className="text-gray-600  mb-3">
                        {t("principles.principle2.description")}
                    </p>
                    <div className="bg-yellow-50 dark:bg-yellow-900 p-3 rounded border-l-4 border-yellow-500">
                        <p className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                            <span className="font-bold">
                                ⚠️ {t("important")}:
                            </span>{" "}
                            {t("principles.principle2.important")}
                        </p>
                    </div>
                </div>

                <div className="bg-gray-50  p-4 rounded-lg mb-10 border-l-4 border-green-600 rounded-none">
                    <h3 className="text-xl font-medium mb-2">
                        {t("principles.principle3.title")}
                    </h3>
                    <p className="text-gray-600  mb-3">
                        {t("principles.principle3.description")}
                    </p>
                </div>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <InternalLink
                    to="/docs/platform"
                    className="border rounded-lg p-6 hover:shadow-lg transition-shadow"
                >
                    <div className="mb-4">
                        <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                            <span className="text-purple-600 text-xl">✨</span>
                        </div>
                    </div>
                    <h3 className="text-xl font-semibold mb-2">
                        Platform Overview
                    </h3>
                    <p className="text-gray-600 ">
                        Explore how Agent UI can help you automate tasks,
                        generate content, and build applications through simple
                        conversations with AI.
                    </p>
                </InternalLink>

                <InternalLink
                    to="/docs/automation"
                    className="border rounded-lg p-6 hover:shadow-lg transition-shadow"
                >
                    <div className="mb-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                            <span className="text-blue-600 text-xl">🤖</span>
                        </div>
                    </div>
                    <h3 className="text-xl font-semibold mb-2">Automation</h3>
                    <p className="text-gray-600 ">
                        Learn how to create powerful automations by simply
                        describing what you want to accomplish.
                    </p>
                </InternalLink>

                <InternalLink
                    to="/docs/use-cases"
                    className="border rounded-lg p-6 hover:shadow-lg transition-shadow"
                >
                    <div className="mb-4">
                        <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                            <span className="text-green-600 text-xl">📊</span>
                        </div>
                    </div>
                    <h3 className="text-xl font-semibold mb-2">Use Cases</h3>
                    <p className="text-gray-600 ">
                        Discover popular automation scenarios and how Agent UI
                        transforms complex workflows into simple conversations.
                    </p>
                </InternalLink>
            </div>

            <div className="flex justify-end">
                <InternalLink
                    to="/docs/platform"
                    className="text-blue-600 hover:text-blue-700 font-medium"
                >
                    Explore the platform →
                </InternalLink>
            </div>

            <div className="flex gap-4 mt-12">
                <a
                    href="https://twitter.com"
                    className="text-gray-500 hover:text-gray-700"
                >
                    <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                    </svg>
                </a>
                <a
                    href="https://github.com"
                    className="text-gray-500 hover:text-gray-700"
                >
                    <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fillRule="evenodd"
                            d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </a>
                <a
                    href="https://linkedin.com"
                    className="text-gray-500 hover:text-gray-700"
                >
                    <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
                    </svg>
                </a>
            </div> */}
        </div>
    );
}

export default DocsIntro;
